export default "__VITE_ASSET__DWymQbRK__"